<template>
  <b-row>
    <b-col xl="3" md="6">
      <stats-card
        title="Total Events"
        type="gradient-red"
        :sub-title="stats.totalEvents.toString()"
        icon="ni ni-active-40"
      >
      </stats-card>
    </b-col>
    <b-col xl="3" md="6">
      <stats-card
        title="Active Beacons"
        type="gradient-orange"
        :sub-title="stats.activeBeacons.toString()"
        icon="ni ni-chart-pie-35"
      >
      </stats-card>
    </b-col>
    <b-col xl="3" md="6">
      <stats-card
        title="Devices Online"
        type="gradient-green"
        :sub-title="stats.devicesOnline.toString()"
        icon="ni ni-mobile-button"
      >
      </stats-card>
    </b-col>
    <b-col xl="3" md="6">
      <stats-card
        title="Last Update"
        type="gradient-info"
        :sub-title="stats.lastUpdate"
        icon="ni ni-time-alarm"
      >
      </stats-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'BeaconStats',
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({
        totalEvents: 0,
        activeBeacons: 0,
        devicesOnline: 0,
        lastUpdate: 'Never'
      })
    }
  }
}
</script>